import PropTypes from "prop-types";

/**
 * RecipeFox AI logo mark.
 * A geometric fox head built from sharp triangles + a chef knife as the muzzle stripe.
 * Pairs with editorial typography for the wordmark.
 */
export function FoxMark({ size = 32, className = "", color = "currentColor" }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 64 64"
            fill="none"
            className={className}
            aria-label="RecipeFox AI"
        >
            {/* Outer fox head - hard angular */}
            <path
                d="M32 4 L8 18 L4 36 L20 60 L44 60 L60 36 L56 18 Z"
                fill={color}
            />
            {/* Inner face - cut-out triangles for ears effect */}
            <path d="M14 16 L24 26 L18 32 Z" fill="#FDFBF7" />
            <path d="M50 16 L40 26 L46 32 Z" fill="#FDFBF7" />
            {/* Eyes */}
            <circle cx="24" cy="34" r="2.4" fill="#FDFBF7" />
            <circle cx="40" cy="34" r="2.4" fill="#FDFBF7" />
            {/* Knife / muzzle stripe */}
            <path d="M28 42 L36 42 L38 46 L32 52 L26 46 Z" fill="#FDFBF7" />
            <rect x="31" y="44" width="2" height="6" fill={color} />
        </svg>
    );
}

FoxMark.propTypes = {
    size: PropTypes.number,
    className: PropTypes.string,
    color: PropTypes.string,
};

export function Wordmark({ className = "" }) {
    return (
        <span className={`heading inline-flex items-baseline gap-1 leading-none ${className}`}>
            <span>RecipeFox</span>
            <span className="font-mono text-[0.55em] tracking-wider text-klein -translate-y-1">AI</span>
        </span>
    );
}

Wordmark.propTypes = {
    className: PropTypes.string,
};

export default function Logo({ size = 32, withWordmark = true, className = "" }) {
    return (
        <span className={`inline-flex items-center gap-2 ${className}`}>
            <FoxMark size={size} color="#111111" />
            {withWordmark && <Wordmark className="text-base" />}
        </span>
    );
}

Logo.propTypes = {
    size: PropTypes.number,
    withWordmark: PropTypes.bool,
    className: PropTypes.string,
};
